/**
 * Coups de pouce, Attendus 1246 « calculer une moyenne », 1247 « donner
 * une médiane pour une série comportant un petit nombre de valeurs »,
 * 1248 « calculer l'étendue d'une série » (3e, Statistiques ; un fichier
 * gen_1246 à trois jeux de clés). Seconde passe 3e (2026-09-13).
 * UNE page par attendu, sur la MÊME série : chaque attendu ne reçoit que
 * la page de son indicateur (décision prof 2026-09-19 : ne pas surcharger
 * l'aide avec les deux autres indicateurs, même s'ils sont ce que les
 * cartes confondent, les distracteurs s'en chargent).
 *
 * L'image que l'élève a déjà : la série écrite en ligne et RANGÉE (5e,
 * 4e : « je range d'abord »), les valeurs sur des cartes.
 *   « La moyenne : je partage » : 3, 5, 8, 12, 17 ; somme 45 ; 45 ÷ 5 = 9
 *     (je divise par le nombre de valeurs, 5, pas par 4).
 *   « La médiane : je range, je prends le milieu » : rangée, la valeur du
 *     milieu, autant de valeurs avant qu'après : 8 (pas 9, pas 10). Et le
 *     cas PAIR sur la même page (demande prof 2026-09-19, le gen sert des
 *     séries de 4 et 6 valeurs) : 3, 5, 8, 12, deux valeurs au milieu, la
 *     médiane est au milieu des deux : (5 + 8) ÷ 2 = 6,5.
 *   « L'étendue : le plus grand moins le plus petit » : 17 − 3 = 14.
 *
 * SACRIFIÉS : les multisets {3, 5, 8, 12, 17} et {3, 5, 8, 12} dans tous
 * les ordres (gen_1246, gen1246-1248.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';
const BLEU_CLAIR = '#DBEAFE';
const ORANGE_CLAIR = '#FED7AA';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const gras = (t, couleur = ENCRE) => `<tspan font-weight="bold" fill="${couleur}">${t}</tspan>`;

const SERIE = [3, 5, 8, 12, 17];
const SERIE_PAIRE = [3, 5, 8, 12];
/** Les cartes d'une série rangée, centrées, la k-ième (ou toutes) en couleur. */
const cartes = (y, colore = () => false, serie = SERIE) => serie.map((v, k) => {
    const x = 200 + (k - (serie.length - 1) / 2) * 54;
    const c = colore(k, v);
    return `<rect x="${x - 20}" y="${y - 18}" width="40" height="30" rx="6" fill="${c ? ORANGE_CLAIR : BLEU_CLAIR}" stroke="${c ? ORANGE : BLEU}" stroke-width="1.4"/>
  <text x="${x}" y="${y + 4}" font-size="16" font-weight="bold" text-anchor="middle" fill="${c ? ORANGE : BLEU}">${v}</text>`;
}).join('\n  ');
const ENTETE = (y) => `<text x="200" y="${y}" font-size="11" text-anchor="middle" fill="${GRIS}">la série, rangée du plus petit au plus grand (5 valeurs)</text>`;

const SVG_MOYENNE = svg(
    'La série 3, 5, 8, 12, 17, cinq valeurs. La moyenne : j’additionne tout, 3 plus 5 plus 8 plus 12 plus 17 égale 45, puis je partage entre les 5 valeurs : 45 divisé par 5 égale 9. Je divise par le nombre de valeurs, 5, pas par 4.',
    `${ENTETE(30)}
  ${cartes(60)}
  ${ligne(112, `somme : 3 + 5 + 8 + 12 + 17 = ${gras('45')}`, 14)}
  ${ligne(142, `je partage entre les ${gras('5', BLEU)} valeurs : 45 ÷ ${gras('5', BLEU)} = ${gras('9', ORANGE)}`, 14)}
  ${ligne(184, 'La moyenne, c’est « si tout le monde avait pareil » : 9 chacun.', 12)}
  ${ligne(206, 'Je divise par le nombre de valeurs : 5.', 12, GRIS)}`,
    222,
);

const SVG_MEDIANE = svg(
    'Deux séries rangées. Cinq valeurs, 3, 5, 8, 12, 17 : une seule valeur au milieu, en orange, 8 ; deux valeurs avant, deux valeurs après ; la médiane est 8. Quatre valeurs, 3, 5, 8, 12 : deux valeurs au milieu, 5 et 8 ; la médiane est au milieu des deux, 5 plus 8 divisé par 2 égale 6,5. Je range d’abord, puis je prends le milieu ; ce n’est ni la moyenne, ni le milieu entre le plus petit et le plus grand.',
    `<text x="200" y="30" font-size="11" text-anchor="middle" fill="${GRIS}">5 valeurs (nombre impair), rangées du plus petit au plus grand</text>
  ${cartes(60, (k) => k === 2)}
  <text x="146" y="92" font-size="11" text-anchor="middle" fill="${GRIS}">2 valeurs avant</text>
  <text x="254" y="92" font-size="11" text-anchor="middle" fill="${GRIS}">2 valeurs après</text>
  ${ligne(116, `une seule valeur au ${gras('milieu', ORANGE)} : la médiane est ${gras('8', ORANGE)}`, 14)}

  <text x="200" y="152" font-size="11" text-anchor="middle" fill="${GRIS}">4 valeurs (nombre pair), rangées du plus petit au plus grand</text>
  ${cartes(182, (k) => k === 1 || k === 2, SERIE_PAIRE)}
  <text x="200" y="214" font-size="11" text-anchor="middle" fill="${GRIS}">deux valeurs au milieu</text>
  ${ligne(238, `la médiane est au milieu des deux : (${gras('5', ORANGE)} + ${gras('8', ORANGE)}) ÷ 2 = ${gras('6,5', ORANGE)}`, 14)}

  ${ligne(274, 'Je range d’abord, puis je prends le milieu : autant avant qu’après.', 12)}
  ${ligne(296, 'Ce n’est pas la moyenne, ni le milieu entre le plus petit et le plus grand.', 12, GRIS)}`,
    312,
);

const SVG_ETENDUE = svg(
    'La série rangée 3, 5, 8, 12, 17. L’étendue, c’est le plus grand moins le plus petit : 17 moins 3 égale 14. Elle dit à quel point les valeurs sont écartées.',
    `${ENTETE(30)}
  ${cartes(60, (k) => k === 0 || k === 4)}
  <text x="92" y="92" font-size="11" text-anchor="middle" fill="${ORANGE}">le plus petit</text>
  <text x="308" y="92" font-size="11" text-anchor="middle" fill="${ORANGE}">le plus grand</text>
  ${ligne(126, `l’étendue : ${gras('17', ORANGE)} − ${gras('3', ORANGE)} = ${gras('14')}`, 14)}
  ${ligne(166, 'Le plus grand moins le plus petit : l’écart entre les deux bouts.', 12)}
  ${ligne(188, 'Ce n’est pas 17 tout seul, ni 17 + 3.', 12, GRIS)}`,
    204,
);

const AIDE_MOYENNE = { pages: [{ titre: 'La moyenne : je partage', svg: SVG_MOYENNE }] };
const AIDE_MEDIANE = { pages: [{ titre: 'La médiane : je range, je prends le milieu', svg: SVG_MEDIANE }] };
const AIDE_ETENDUE = { pages: [{ titre: 'L’étendue : le plus grand moins le plus petit', svg: SVG_ETENDUE }] };

const CP_1246 = { moy_flash_texte_trou_saisie: AIDE_MOYENNE, moy_qcm_unique: AIDE_MOYENNE, moy_tableau_vf: AIDE_MOYENNE };
export const CP_1247 = { med_flash_texte_trou_saisie: AIDE_MEDIANE, med_qcm_unique: AIDE_MEDIANE, med_tableau_vf: AIDE_MEDIANE };
export const CP_1248 = { etd_flash_texte_trou_saisie: AIDE_ETENDUE, etd_qcm_unique: AIDE_ETENDUE, etd_tableau_vf: AIDE_ETENDUE };

export default CP_1246;
